import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrowsePageService_GetBrowseUSPsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useGetBrowseUsps = () => {
  const session = useOptionalSession();
  const targetGroup = useTargetGroupIdentifier();

  return useGrpcRequest(BrowsePageService_GetBrowseUSPsLazy, {
    session,
    targetGroup,
  });
};
